const Config = {
    UNSPLASH_CLIENT_ID: "3af178b0b4c03efc687535ae6f1131cc6ff2b036f3f34c7445bc805808a5d251",

    DASHBOARD_API_ENDPOINT: "https://dashboard.schmuckli.net/",
    
    DEFAULT_OAUTH_SETTINGS_REDIRECT_URI: "https://dashboard.schmuckli.dev/oauth_complete.html"
};

export default Config;